

























import { Component, Prop, Mixins, Inject } from "vue-property-decorator";
import Context from "@/mixins/context";
import { DataModules } from "@/store/modules/data";
import { IClient } from "@/models/clients";
import {
  IClientProviderData,
  IClientProviderMethods
} from "@/models/providers/client";
import { QUERY_PARAMS } from "@/data/constants";
import { RegexMatch } from "@/data/enums/router";
import { IQuickAction } from "@/models/actions";

@Component
export default class ClientQuickActions extends Mixins(Context) {
  // Inject

  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  @Inject({ from: "clientMethods" })
  public readonly $clientMethods!: IClientProviderMethods;

  // Props
  @Prop({ required: true })
  public readonly client!: IClient;

  // Data
  public isProcessing: string[] = [];

  // Computed

  public get $clientData() {
    return this.$clientProvider();
  }

  public get isStaged() {
    return this.$clientData.isStaged;
  }

  public get actions(): IQuickAction[] {
    return [
      {
        label: this.$t("_action.place_new_order"),
        method: () =>
          this.$router.push({
            name: "adminOrderShop",
            params: { basketId: RegexMatch.NEW },
            query: {
              [QUERY_PARAMS.CLIENT_ID]: this.$_.get(this.client, "id"),
              [QUERY_PARAMS.ACCOUNT_ID]: this.$_.get(
                this.client,
                "accounts[0].id"
              )
            }
          }),
        icon: "shopping-basket",
        if: this.isAdmin
      },
      {
        label: this.$t("_action.open_new_ticket"),
        method: this.openNewTicketModal,
        icon: "life-ring",
        if: this.isAdmin
      },
      {
        label: this.$t("_action.impersonate_client"),
        method: () =>
          this.process(
            "client_impersonation",
            this.$clientMethods.impersonateClient()
          ),
        if: this.isAdmin,
        disabled: !this.$clientData.canImpersonateClient,
        icon: "mask",
        isProcessing: this.isProcessing.includes("client_impersonation")
      },
      {
        label: this.$t("_action.login_to_upmind_instance"),
        method: () =>
          this.process(
            "org_impersonation",
            this.$clientMethods.impersonateUser()
          ),
        if: this.isAdmin && this.$store.getters.isUpmindContext,
        icon: "id-card-alt",
        isProcessing: this.isProcessing.includes("org_impersonation"),
        ...(!this.$clientData.canImpersonateOrg
          ? {
              disabled: true,
              tooltip: {
                label: this.$t(
                  "_sentence.upmind.remote_access_not_enabled_msg"
                ),
                multilined: true,
                type: "is-danger",
                size: "is-small"
              }
            }
          : {})
      },
      {
        label: this.$t("_action.send_email"),
        method: this.openSendEmailModal,
        icon: "envelope",
        if: this.isAdmin
      }
    ];
  }

  public get availableActions() {
    return this.$_.filter(this.actions, action => action.if);
  }

  // Methods

  public async process(key: string, method: Promise<any>) {
    try {
      this.$set(this, "isProcessing", this.$_.union(this.isProcessing, [key]));
      await method;
    } finally {
      this.$set(this, "isProcessing", this.$_.without(this.isProcessing, key));
    }
  }

  public openSendEmailModal() {
    return this.$store.dispatch(
      `data/${DataModules.TEMPLATES}/openSendEmailModal`,
      {
        props: {
          type: "client",
          objectId: this.$_.get(this.client, "id"),
          title: this.$t("_action.send_object", {
            object: (this.$t("_.object_email", {
              object: (this.$t("_.client") as string).toLowerCase()
            }) as string).toLowerCase()
          })
        }
      }
    );
  }

  public openNewTicketModal() {
    this.$store.dispatch("data/tickets/openNewTicketModal", {
      clientId: this.$_.get(this.client, "id"),
      accountId: this.$_.get(this.client, "accounts[0].id"),
      brandId: this.$_.get(this.client, "brand_id")
    });
  }
}
